<small class="debug">{{me}}</small>
<div fxLayout="row" fxLayoutAlign="space-between center" style="padding: 0 5px;">
  <mat-form-field class="filter">
    <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
    <input inputrestriction="basic1" matInput type="text" name="SearchDualList" class="form-control" (keyup)="changeSearchKey()"
      [(ngModel)]="filter" autocomplete="off"/>
    <a matSuffix aria-label="clear" (click)="clearSearchKey()">
      <mat-icon>close</mat-icon>
    </a>
  </mat-form-field>
  <div fxLayout="row">
    <fa-icon class="control-icon" [ngClass]="{'inactive': activeIds[0] == selectedSceneId}" [icon]="faLock" (click)="toggleLockedItem($event, true)" matTooltip="{{'general.lockItem' | transloco}}"></fa-icon>
    <fa-icon class="control-icon" [ngClass]="{'inactive': activeIds[0] == selectedSceneId}" [icon]="faEyeSlash" (click)="toggleInvisibleItem($event, true)" matTooltip="{{'general.hideItem' | transloco}}"></fa-icon>
  </div>
  <div class="hide-gt-sm">
    <app-scroll-buttons contentId="items"></app-scroll-buttons>
  </div>
  <app-video-link videoLink="layers"></app-video-link>
</div>

<div class="scene-tree" id="items">
  <!-- root node -->
  @if (rootNode) {
    <div id="layer_{{selectedSceneId}}" class="root-node" (click)="onItemClick(rootNode, $event)" [ngClass]="{ 'background-highlight': activeIds.indexOf(selectedSceneId) > -1}">
      <button mat-icon-button (click)="expandTree1 = !expandTree1" class="mini-button">
        <fa-icon [icon]="expandTree1 ? faFolderOpen : faFolder"></fa-icon>
      </button>
      <span>{{rootNode.filename}}</span>
    </div>
  }

  <!-- node list -->
  @if (expandTree1) {
    <div>
      @for (node of filteredSource['fixed']; track node) {
        <div class="drag-item-area disable-selection">
          <div id="layer_{{node.id}}">
            <span class="mimetype-icon"><fa-icon [icon]="node.icon"></fa-icon></span>
            <fa-icon class="tree-icon pull-right color-blue" [icon]="faImage" (click)="toggleLockedItem($event, false, node)" matTooltip="{{'general.background' | transloco}}"></fa-icon>
            <span>{{node.filename}}</span>
          </div>
        </div>
      }
      <div cdkDropList class="node-list" (cdkDropListDropped)="dropItem($event)" [cdkDropListData]="filteredSource['common']">
        @for (node of filteredSource['common']; track node) {
          <div class="drag-item-area" cdkDrag [cdkDragData]="node" (click)="onItemClick(node, $event)" [cdkDragDisabled]="node.invisible || node.locked"
            [ngClass]="{ 'background-highlight': activeIds.indexOf(node.id) > -1, 'disable-selection': node.invisible || node.locked }">
            <div id="layer_{{node.id}}">
              <span class="mimetype-icon">
                <fa-icon [icon]="node.mimeType ? (node.mimeType | PipeIcon) : node.icon"></fa-icon>
              </span>
              @if (node.locked) {
                <fa-icon class="tree-icon pull-right color-red" [icon]="faLock" (click)="toggleLockedItem($event, false, node)"></fa-icon>
              }
              @if (node.invisible) {
                <fa-icon class="tree-icon pull-right color-red" [icon]="faEyeSlash" (click)="toggleInvisibleItem($event, false, node)"></fa-icon>
              }
              <span>{{node.filename}}</span>
            </div>
            <div class="drag-custom-placeholder" *cdkDragPlaceholder></div>
          </div>
        }
      </div>
    </div>
  }
</div>
